module.exports = __webpack_public_path__ + "static/media/view-support-card.07479cfc.jpg";